import { Component } from '@theme/component';

/**
 * Indéscents — suivi de commande.
 * Reconnaît le transporteur d'après le format du numéro et renvoie vers son suivi réel.
 * Aucun statut n'est inventé ici : l'état du colis vient du transporteur.
 * TODO (dev ultérieur) : afficher le statut en direct via l'API de la commande Shopify.
 */
const CARRIERS = [
  { id: 'colissimo', nom: 'Colissimo · La Poste', test: /^(6[AC]|8[RQ]|7[AQ]|1[AKLJ]|CP|CD|CJ|EA|EE)[0-9A-Z]{9,11}$/i,
    url: (n) => `https://www.laposte.fr/outils/suivre-vos-envois?code=${n}` },
  { id: 'chronopost', nom: 'Chronopost', test: /^(X[A-Z]|[A-Z]{2}\d{9}FR)$/i,
    url: (n) => `https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=${n}` },
  { id: 'mondialrelay', nom: 'Mondial Relay', test: /^\d{8}$/,
    url: (n) => `https://www.mondialrelay.fr/suivi-de-colis/?numeroExpedition=${n}` },
  { id: 'ups', nom: 'UPS', test: /^1Z[0-9A-Z]{16}$/i,
    url: (n) => `https://www.ups.com/track?loc=fr_FR&tracknum=${n}` },
  { id: 'dhl', nom: 'DHL', test: /^\d{10}$/,
    url: (n) => `https://www.dhl.com/fr-fr/home/tracking.html?tracking-id=${n}` },
  { id: 'dpd', nom: 'DPD', test: /^\d{14}$/,
    url: (n) => `https://www.dpd.fr/trace/${n}` },
];
// Repli : un moteur multi-transporteurs, qui reconnaît la plupart des formats.
const FALLBACK = {
  nom: 'Recherche multi-transporteurs',
  url: (n) => `https://www.laposte.fr/outils/suivre-vos-envois?code=${n}`,
};

class IndescentsSuivi extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.form = this.querySelector('[data-form]');
    this.input = this.querySelector('[data-input]');
    this.err = this.querySelector('[data-err]');
    this.res = this.querySelector('[data-res]');
    this.numEl = this.querySelector('[data-num]');
    this.carrierEl = this.querySelector('[data-carrier]');
    this.link = this.querySelector('[data-link]');
    this.form?.addEventListener('submit', (e) => { e.preventDefault(); this.lookup(); });
    this.input?.addEventListener('input', () => this.clearError());

    // ?numero=… dans l'URL (lien depuis l'e-mail d'expédition)
    const fromUrl = new URLSearchParams(location.search).get('numero');
    if (fromUrl && this.input) { this.input.value = fromUrl; this.lookup(); }
  }

  clean() { return (this.input?.value || '').replace(/[\s-]/g, '').trim(); }

  clearError() { if (this.err) { this.err.hidden = true; this.err.textContent = ''; } }

  showError(msg) {
    if (this.res) this.res.hidden = true;
    if (!this.err) return;
    this.err.textContent = msg;
    this.err.hidden = false;
  }

  lookup() {
    const n = this.clean();
    if (!n) { this.showError('Entre ton numéro de suivi pour continuer.'); this.input?.focus(); return; }
    if (!/^[0-9A-Za-z]+$/.test(n)) { this.showError('Un numéro de suivi ne contient que des lettres et des chiffres.'); return; }
    if (n.length < 8 || n.length > 22) { this.showError('Ce numéro ne ressemble pas à un numéro de suivi (entre 8 et 22 caractères).'); return; }
    this.clearError();

    const carrier = CARRIERS.find((c) => c.test.test(n)) || FALLBACK;
    if (this.numEl) this.numEl.textContent = n.toUpperCase();
    if (this.carrierEl) this.carrierEl.textContent = carrier.nom;
    if (this.link) {
      this.link.href = carrier.url(encodeURIComponent(n));
      this.link.textContent = carrier === FALLBACK ? 'Rechercher mon colis' : `Voir le suivi chez ${carrier.nom.split(' · ')[0]}`;
    }
    if (this.res) {
      this.res.hidden = false;
      this.res.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }
}

if (!customElements.get('indescents-suivi')) customElements.define('indescents-suivi', IndescentsSuivi);
